var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "054-symbols",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.213,
    height: 73.37,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 18022"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 18021"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6782",
    d: "M110.3 0H2.915A2.913 2.913 0 0 0 0 2.915v67.54a2.913 2.913 0 0 0 2.915 2.915H110.3a2.913 2.913 0 0 0 2.915-2.915V2.915A2.913 2.913 0 0 0 110.3 0ZM8.766 22.171h12.083c1.63.062 2.943.581 3.4 2.323l2.628 12.638c-2.582-6.611-8.8-12.111-18.207-14.388Zm14.62 28.825-6.979-23.845c5.017 3.21 9.293 8.31 10.793 11.852l.814 2.945 7.633-19.5h8.258L31.635 50.99Zm26.591.02h-7.793l4.873-28.6h7.8Zm13.562.429a24.671 24.671 0 0 1-8.683-1.527l1.1-6.4 1 .455a16.333 16.333 0 0 0 7.338 1.5c2.239 0 4.638-.876 4.66-2.792.014-1.253-1-2.147-4.039-3.55-2.957-1.37-6.873-3.66-6.825-7.77.042-5.558 5.47-9.437 13.173-9.437a20.117 20.117 0 0 1 6.982 1.2l-1.052 6.2-.7-.331a14.381 14.381 0 0 0-5.833-1.094c-3.051 0-4.466 1.271-4.466 2.459-.016 1.339 1.652 2.221 4.378 3.548 4.5 2.041 6.575 4.516 6.547 7.769-.065 5.937-5.383 9.77-13.579 9.77Zm33.775-.417s-.712-3.287-.948-4.286c-1.135 0-9.088-.012-9.982-.012-.3.772-1.638 4.3-1.638 4.3h-8.183l11.572-26.211c.822-1.862 2.215-2.373 4.083-2.373h6.021l6.308 28.58Z",
    fill: "#4e87ae"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 18024"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 18023"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 6783",
    d: "m93.292 32.625-.525-2.465c-.4 1.076-1.08 2.806-1.036 2.73 0 0-2.463 6.348-3.1 7.994h6.472c-.317-1.434-1.811-8.259-1.811-8.259Z",
    fill: "#4e87ae"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6eee00630432f6c52081dc07fcc5a4c4.svg";
export { ForwardRef as ReactComponent };